import { ThemeConfig } from 'antd';
import { colors } from 'theme/colors';

export const lightTheme: ThemeConfig = {
  token: {
    ...colors,
    fontFamily: 'PP Neue Montreal',
    fontWeightStrong: 500,
    fontSizeSM: 12,
    fontSize: 14,
    fontSizeLG: 16,
  },
  components: {
    Typography: {
      fontWeightStrong: 500,
      colorLinkHover: colors.colorPrimaryActive,
      colorLinkActive: colors.colorPrimaryActive,
      colorLink: colors.colorPrimary,
    },
    Input: {
      paddingInlineSM: 7,
      paddingInlineLG: 11,
      paddingInline: 11,
      paddingBlockSM: 0,
      paddingBlockLG: 7,
      paddingBlock: 4,
      hoverBorderColor: colors.colorPrimaryActive,
      activeBorderColor: colors.colorPrimary,
      colorPrimary: colors.colorPrimary,
    },
    Transfer: {
      listWidthLG: 250,
      listWidth: 180,
      listHeight: 200,
      itemPaddingBlock: 5,
    },
    Segmented: {
      itemColor: colors.ledgerWhite7,
    },
    Switch: {
      trackPadding: 2,
      trackMinWidthSM: 28,
      trackMinWidth: 44,
      trackHeightSM: 16,
      trackHeight: 22,
      handleSizeSM: 12,
      handleSize: 18,
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
    },
    Timeline: {
      itemPaddingBottom: 20,
      colorPrimary: colors.colorPrimary,
    },
    Tabs: {
      horizontalItemGutter: 32,
      cardGutter: 2,
      itemSelectedColor: colors.colorPrimary,
      itemHoverColor: colors.colorPrimaryActive,
      inkBarColor: colors.colorPrimary,
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
    },
    Table: {
      stickyScrollBarBorderRadius: 100,
      rowHoverBg: colors.colorPrimaryBg,
      bodySortBg: colors.colorFillAlterSolid,
      fontWeightStrong: 500,
      colorPrimary: colors.colorPrimary,
      colorLink: colors.colorPrimary,
    },
    Steps: {
      dotSize: 8,
      dotCurrentSize: 10,
      fontWeightStrong: 500,
      colorPrimary: colors.colorPrimary,
    },
    Spin: {
      dotSizeSM: 14,
      dotSize: 20,
      contentHeight: 400,
      colorPrimary: colors.colorPrimary,
    },
    Slider: {
      railSize: 4,
      handleSizeHover: 12,
      dotSize: 8,
      controlSize: 10,
      handleSize: 10,
      handleActiveColor: colors.colorPrimary,
      handleColorDisabled: '#bfbfbf',
      colorPrimary: colors.colorPrimary,
    },
    Rate: {
      starSize: 20,
    },
    Radio: {
      radioSize: 16,
      dotSize: 8,
      buttonPaddingInline: 15,
      buttonSolidCheckedHoverBg: colors.colorPrimaryActive,
      buttonSolidCheckedBg: colors.colorPrimary,
      colorBgBase: colors.colorPrimary,
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
    },
    Popover: {
      titleMinWidth: 177,
      fontWeightStrong: 500,
    },
    Notification: {
      width: 384,
    },
    Menu: {
      subMenuItemBg: colors.colorPrimary,
      darkSubMenuItemBg: colors.ledgerWhite8,
      darkItemDisabledColor: 'rgba(255, 255, 255, 0.25)',
      darkItemColor: colors.ledgerWhite2,
      darkGroupTitleColor: 'rgba(255, 255, 255, 0.65)',
      darkItemBg: colors.ledgerWhite7,
      popupBg: colors.colorPrimary,
      itemSelectedColor: colors.ledgerWhite1,
      itemSelectedBg: colors.ledgerWhite4,
      itemHoverColor: colors.ledgerWhite1,
      itemHoverBg: colors.ledgerWhite1,
      itemColor: colors.ledgerWhite1,
      itemBg: colors.colorPrimaryActive,
      horizontalItemSelectedColor: colors.colorPrimary,
      horizontalItemSelectedBg: 'rgba(0, 0, 0, 0.00)',
      horizontalItemHoverColor: colors.colorPrimaryActive,
      horizontalItemHoverBg: 'rgba(0, 0, 0, 0.00)',
      darkItemSelectedBg: colors.colorPrimary,
      darkItemHoverBg: 'rgba(0, 0, 0, 0.00)',
      darkPopupBg: colors.ledgerWhite8,
      activeBarBorderWidth: 1,
      collapsedWidth: 80,
      dropdownWidth: 160,
      itemMarginInline: 4,
      iconMarginInlineEnd: 10,
      colorPrimary: colors.colorPrimary,
      colorBgContainer: colors.colorPrimary,
    },
    InputNumber: {
      paddingInlineSM: 7,
      paddingInlineLG: 11,
      paddingInline: 11,
      paddingBlockSM: 0,
      paddingBlockLG: 7,
      paddingBlock: 4,
      handleWidth: 22,
      controlWidth: 90,
      hoverBorderColor: colors.colorPrimaryActive,
      handleHoverColor: colors.colorPrimary,
      activeBorderColor: colors.colorPrimary,
      filledHandleBg: colors.colorFilledHandleBg,
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
    },
    Image: {
      previewOperationSize: 18,
      previewOperationHoverColor: 'rgba(255, 255, 255, 0.85)',
      previewOperationColorDisabled: 'rgba(255, 255, 255, 0.25)',
      previewOperationColor: 'rgba(255, 255, 255, 0.65)',
    },
    Card: {
      headerHeightSM: 38,
      headerHeight: 56,
      headerBg: 'rgba(0, 0, 0, 0.00)',
      fontWeightStrong: 500,
      colorPrimary: colors.colorPrimary,
      bodyPadding: 16,
      colorBorderSecondary: colors.colorBgLayout,
      colorBgContainer: colors.colorFillAlterSolid,
    },
    Carousel: {
      dotWidth: 16,
      dotHeight: 3,
      dotActiveWidth: 24,
    },
    Cascader: {
      dropdownHeight: 180,
      controlWidth: 184,
      controlItemWidth: 111,
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
    },
    Calendar: {
      yearControlWidth: 80,
      monthControlWidth: 70,
      fontWeightStrong: 500,
      colorPrimary: colors.colorPrimary,
      colorLinkHover: colors.colorPrimaryActive,
      colorLink: colors.colorPrimary,
    },
    Button: {
      paddingInlineSM: 7,
      paddingInlineLG: 15,
      paddingInline: 15,
      onlyIconSizeSM: 12,
      onlyIconSizeLG: 18,
      textHoverBg: colors.ledgerWhite1,
      linkHoverBg: 'rgba(0, 0, 0, 0.00)',
      ghostBg: 'rgba(0, 0, 0, 0.00)',
      defaultHoverColor: colors.ledgerWhite8,
      defaultHoverBorderColor: colors.ledgerWhite8,
      fontWeight: 400,
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimaryActive: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
      colorLink: colors.colorPrimary,
    },
    Badge: {
      statusSize: 6,
      indicatorHeight: 20,
      dotSize: 6,
      colorPrimary: colors.colorPrimaryActive,
    },
    Form: {
      colorPrimary: colors.colorPrimary,
      labelColonMarginInlineStart: 2,
    },
    Avatar: {
      colorTextPlaceholder: colors.smartGrey3,
      textFontSize: 18,
    },
    Tour: {
      fontWeightStrong: 500,
      colorPrimary: colors.colorPrimary,
      colorBgTextHover: colors.ledgerWhite1,
      closeBtnSize: 22,
      primaryNextBtnHoverBg: colors.colorFilledHandleBg,
      primaryPrevBtnBg: 'rgba(255, 255, 255, 0.15)',
    },
    Upload: {
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
    },
    TreeSelect: {
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
    },
    Tree: {
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
      directoryNodeSelectedBg: colors.colorPrimary,
    },
    Tag: {
      defaultBg: colors.mauveGrey1,
      defaultColor: colors.colorText,
      fontSizeSM: 14,
    },
    Select: {
      optionActiveBg: colors.colorPrimaryBg,
      fontWeightStrong: 500,
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
      multipleItemBorderColorDisabled: 'rgba(0, 0, 0, 0.00)',
      multipleItemBorderColor: 'rgba(0, 0, 0, 0.00)',
      showArrowPaddingInlineEnd: 18,
    },
    Result: {
      colorInfo: colors.colorPrimary,
      iconFontSize: 72,
    },
    Progress: {
      defaultColor: colors.colorPrimary,
    },
    Popconfirm: {
      fontWeightStrong: 500,
    },
    Pagination: {
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
      colorBgTextHover: colors.ledgerWhite1,
    },
    Modal: {
      fontWeightStrong: 500,
      footerBg: 'rgba(0, 0, 0, 0.00)',
      titleFontSize: 16,
    },
    List: {
      colorPrimary: colors.colorPrimary,
      headerBg: 'rgba(0, 0, 0, 0.00)',
      footerBg: 'rgba(0, 0, 0, 0.00)',
    },
    FloatButton: {
      controlItemBgHover: colors.ledgerWhite1,
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
    },
    Dropdown: {
      controlItemBgHover: colors.colorPrimaryBg,
      colorPrimary: colors.colorPrimary,
      paddingBlock: 5,
    },
    Drawer: {
      fontWeightStrong: 500,
      lineWidthFocus: 4,
    },
    Descriptions: {
      fontWeightStrong: 500,
    },
    DatePicker: {
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
      colorLink: colors.colorPrimary,
      hoverBorderColor: colors.colorPrimaryActive,
      activeBorderColor: colors.colorPrimary,
      paddingInline: 11,
      paddingInlineSM: 7,
      cellHoverWithRangeBg: '#c8dfff',
      cellRangeBorderColor: '#7cb3ff',
      multipleItemBorderColor: 'rgba(0, 0, 0, 0.00)',
      multipleItemBorderColorDisabled: 'rgba(0, 0, 0, 0.00)',
      cellWidth: 36,
      multipleItemHeight: 24,
      multipleItemHeightLG: 32,
      multipleItemHeightSM: 16,
      paddingBlock: 4,
      paddingBlockLG: 7,
      paddingBlockSM: 0,
      paddingInlineLG: 11,
      presetsMaxWidth: 200,
      presetsWidth: 120,
      timeCellHeight: 28,
      timeColumnHeight: 224,
      timeColumnWidth: 56,
      withoutTimeCellHeight: 66,
    },
    Checkbox: {
      colorPrimaryHover: colors.colorPrimaryActive,
      colorPrimary: colors.colorPrimary,
    },
    Breadcrumb: {
      colorBgTextHover: colors.ledgerWhite1,
    },
    Anchor: {
      colorPrimary: colors.colorPrimary,
    },
    Layout: {
      headerBg: colors.ledgerWhite8,
      siderBg: colors.ledgerWhite9,
      triggerBg: '#002140',
      headerHeight: 50,
      triggerHeight: 48,
    },
    Splitter: {
      resizeSpinnerSize: 20,
      splitBarSize: 2,
      splitTriggerSize: 6,
    },
  },
};
